import React from 'react';
import { Navbar } from '../Navbar';
import { Services } from '../../sections/Services';
import { Contact } from '../../sections/Contact';
import { About } from '../../sections/About';
import { Footer } from '../../sections/Footer';

require('dotenv').config();

const App = () => (
  <>
    <Navbar />
    <Services />
    <Contact />
    <About />
    <Footer />
  </>
);

console.log("NODE_ENV="+process.env.NODE_ENV);

export default App;
